import { Component } from '@angular/core';
import { UpdateCityComponent } from '../../../../components/admin-dashboard-component/cities/update-city-component/update-city-component';

@Component({
  selector: 'app-update-city',
  imports: [UpdateCityComponent],
  templateUrl: './update-city.html',
  styleUrl: './update-city.scss',
})
export class UpdateCity {}
